<div class='about' #about>
    <section>
        <img src="../../assets/img/ExcessMaterialIcon.png" alt="">
    </section>
<!-- 
    <section class="X">
        <a href="/">X</a>
    </section> -->

    <section>
        <p>
            ExcessMaterial.com is your one-stop site to buy, sell, or give away excess materials. You won't have to wade through irrelevant posts that exist on other platforms. Sell or give away material that is too valuable to just discard, or find that extra bit of material you need to finish your job.
        </p>
    </section>
</div>
